import { render } from "./KpiGoalManage.vue?vue&type=template&id=2b3a2040&scoped=true"
import script from "./KpiGoalManage.vue?vue&type=script&lang=js"
export * from "./KpiGoalManage.vue?vue&type=script&lang=js"

import "./KpiGoalManage.vue?vue&type=style&index=0&id=2b3a2040&lang=less&scoped=true"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b3a2040"]])

export default __exports__